// Copyright (c) Zammo Inc.
import React, { useRef } from 'react';
import { connectToWebChat, Components, Constants } from 'botframework-webchat';

import { Caption } from './styles';

const { SpeakActivity } = Components;

const {
  DictateState: { DICTATING },
} = Constants;

type ActivityType = {
  role: string;
  id: string;
  name: string;
};

type Activity = {
  from: ActivityType;
  type: string;
  dictateState: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  activities: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  latestActivity: any;
};

type Props = {
  activities: Activity[];
  dictateState: string;
};

export default connectToWebChat(({ activities, dictateState }: Props) => ({
  dictateState,
  latestActivity: activities
    .slice()
    .reverse()
    .find(({ from: { role }, type }) => role === 'bot' && type === 'message'),
  activities: activities.slice().reverse(),
}))(({ latestActivity, activities, dictateState }: Activity) => {
  const captionRef = useRef<HTMLDivElement | null>(null);
  const lastActivityIsBotMessage = activities && activities.length > 0 && activities[0].from.role === 'bot';

  const lastIndexOfUserActivity = activities.findIndex(
    ({ from: { role }, type }) => role === 'user' && type === 'message'
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let message: any[] = [];
  message.push(<p>{latestActivity?.text}</p>);

  if (lastIndexOfUserActivity > -1) {
    message = [];
    const relevantActivities = activities.slice(0, lastIndexOfUserActivity - 1);
    relevantActivities
      .slice()
      .reverse()
      .forEach(({ text }) => {
        message.push(<p>{text}</p>);
      });
  }

  const caption = !(dictateState === DICTATING) ? (
    <>{lastActivityIsBotMessage && <Caption ref={captionRef}>{message}</Caption>}</>
  ) : (
    <></>
  );

  if (latestActivity) {
    return (
      <>
        {caption}
        {latestActivity?.channelData?.speak && <SpeakActivity activity={latestActivity} />}
      </>
    );
  } else {
    return <></>;
  }
});
